import { useTranslation } from "@outschool/localization";
import React from "react";

export default function useCDPEnrollOrSeeScheduleCTA({
  activity,
}: {
  activity: {
    isClub: boolean;
    isSelfPaced: boolean;
    isSoldOut: boolean;
    upcomingAvailableSectionCount: number;
    canEnroll: boolean;
  };
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\hooks\\useCDPEnrollOrSeeScheduleCTA",
  );

  return React.useMemo(() => {
    if (activity.isClub) {
      return t("Join Group");
    }
    if (activity.isSelfPaced) {
      return t("Enroll");
    }
    if (activity.isSoldOut || !activity.canEnroll) {
      return t("Join Waitlist");
    }
    return t("See Schedule");
  }, [
    t,
    activity.isClub,
    activity.isSelfPaced,
    activity.isSoldOut,
    activity.canEnroll,
  ]);
}
